export const DEFAULT_SCHOOL_FEATURES = {
  attendance: true,
  homework: true,
  exams: true,
  notifications: true,
  transport: false,
  fees: true,
}

export const normalizeSchoolFeatures = (features) => ({
  ...DEFAULT_SCHOOL_FEATURES,
  ...(features || {}),
})
